module.exports = __webpack_public_path__ + "img/pc-background.8e4dec49.webp";